import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import ReactApexChart from 'react-apexcharts'
import ContentLoader from 'Component/ContentLoader'
// @mui
import {styled} from '@mui/material/styles'
import {Card, CardHeader} from '@mui/material'
// utils
// components
import {BaseOptionChart} from '../../../../Component/chart'
import React, {memo, useEffect, useState} from 'react'
import {getUrlOrderRateByShippingStatus} from '../../../../api/url'
import {getData} from '../../../../api/api'
import {formatMoney} from '../../../../util/functionUtil'
import './index.scss'
import {Grid} from '@material-ui/core'
import {ChartOption} from './ChartOption.js'
import {fNumber} from '../../../../util/formatNumber'
import {useTranslation} from 'react-i18next'
import { checkPermission } from 'Component/NavBar/until'
import Empty from '../empty'
// ---------------------------------------------------------------

const EMPTY_SHIPPING_STATUS_IDS = ['1', '2', '22', '3', '4', '5']
const EMPTY_DONUT_COLOR = '#F1F4FA'

const ChartWrapperStyle = styled('div')(({theme}) => ({
  marginTop: '4.5rem',
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible',
  },
  '& .apexcharts-legend': {
    // height: LEGEND_HEIGHT,
    // alignContent: 'center',
    // position: 'relative !important',
    // borderTop: `solid 1px ${theme.palette.divider}`,
    // top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}))

// ----------------------------------------------------------------------

const AppCurrentVisits = function ({
  title,
  subheader,
  startTime,
  endTime,
  ...other
}) {
  const {t} = useTranslation()
  AppCurrentVisits.propTypes = {
    title: PropTypes.string,
    subheader: PropTypes.string,
    chartColors: PropTypes.arrayOf(PropTypes.string),
    chartData: PropTypes.array,
  }
  const [chartData, setChartData] = useState(() =>
    window.localStorage.getItem('chart_data')
      ? JSON.parse(window.localStorage.getItem('chart_data'))
      : [],
  )
  const [loading, setLoading] = useState(chartData.length === 0)
  const validDashboardPermission = checkPermission('dashboard', 'order_rate')

  useEffect(() => {
    // fakeDataUser()
    if (!validDashboardPermission) return
    const url = getUrlOrderRateByShippingStatus(startTime, endTime)
    getData(url)
      .then(res => {
        if (res.data.success) {
          const responseData = Array.isArray(res.data.data) ? res.data.data : []
          const nextChartData = responseData.map(data => ({
            label: data.title,
            value: Number(data.total_orders) || 0,
            price: Number(data.total_cods) || 0,
          }))

          setChartData(nextChartData)
          window.localStorage.setItem('chart_data', JSON.stringify(nextChartData))
        }
      })
      .catch(() => {
        console.log('error')
      })
      .finally(() => setLoading(false))
  }, [startTime, endTime, validDashboardPermission])

  const displayChartData = chartData.length > 0
    ? chartData
    : EMPTY_SHIPPING_STATUS_IDS.map(statusId => ({
      label: t(`delivery_status_${statusId}`),
      value: 0,
      price: 0,
    }))

  const chartLabels = displayChartData.map((i, index) => {
    return (
      `
        <div class="container-shipping">
            <div class="img-content">
                <img src="/img/iconDelivery/shipping` +
      (index + 1) +
      `.svg"  alt="">
            </div>
            <div class="text-content">
              <p class="label-status">${i.label}</p>
              <p class="label-order">${fNumber(i.value)} <span>${t(
        'orders',
      )}</span></p>
              <p class="label-price">${formatMoney(i.price)}</p>
            </div>
        </div>
    `
    )
  })

  const orderTotal = displayChartData.map(i => i.price)
  const chartSeries = displayChartData.map(i => i.value)
  const hasOrderData = chartSeries.some(value => value > 0)
  const displayChartSeries = hasOrderData
    ? chartSeries
    : chartSeries.map((value, index) => index === 0 ? 1 : value)

  const chartOptions = merge(
    BaseOptionChart(),
    ChartOption,
    {
      labels: chartLabels,
      orderTotal: orderTotal,
    },
  )
  const lang = window.localStorage.getItem('i18n') || 'km'

  return (
    <Grid
      className="upos-trans-status-wrapper"
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
    >
      <div className="body-trans-status-wrapper" style={{ height : lang === 'km' ? '480px' : '403px' }}>
        <Card {...other} className="custom-donut">
          <CardHeader
            className="header-donut"
            title={title}
            subheader={subheader}
          />
          {validDashboardPermission ? (
            !loading ? (
              <div>
                <ChartWrapperStyle>
                  <ReactApexChart
                    type="donut"
                    series={displayChartSeries}
                    options={chartOptions}
                    height={200}
                  />
                </ChartWrapperStyle>
              </div>
            ) : (
              <ContentLoader backgroundColor="#FFFFFF" foregroundColor="#F4F7FC">
                <img src="/img/controlpanel/donut-loading.png" alt="loading" />
              </ContentLoader>
            )) : (
            <Empty />
          )}
        </Card>
      </div>
    </Grid>
  )
}
export default memo(AppCurrentVisits)
